import { Injectable } from '@angular/core';
import { CourseResponse } from '../models/course.model';
import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  private apiUrl = `${environment.sgcApi}`;
  private courseRoute = 'course';

  constructor(
    private httpClient: HttpClient
  ) {}

  getCourses(schoolId: number) {
    return this.httpClient.get<CourseResponse[]>(`${this.apiUrl}${this.courseRoute}?filters=schoolId=${schoolId}`)
    .pipe(map((data) => data));
  }
}
